export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_15.54fd4c98.jpg";